export default __webpack_public_path__ + "static/media/Erectus-20-ban.b1493e57.jpg";